import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=cdbcc2ae&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdbcc2ae')) {
      api.createRecord('cdbcc2ae', component.options)
    } else {
      api.reload('cdbcc2ae', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=cdbcc2ae&", function () {
      api.rerender('cdbcc2ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24kNEcCpC97dY/JS/pricehelp.vue"
export default component.exports